import * as React from 'react'
import PhotoUploadIcon from '../icons/ui/PhotoUploadIcon'

//Generate Avatar
import Avatar, { ConfigProvider } from 'react-avatar'

interface IProps {
  entityId?: string
  entityId1?: string
  width?: string
  height?: string
  isRounded?: boolean
  name?: string
  name1?: string
}

interface IState {
  onError: boolean
}

class ImageLiveDrivers extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      onError: false
    }
  }

  public render() {
    const { entityId, entityId1, isRounded } = this.props
    const width = this.props.width || '96px'
    const height = this.props.height || '96px'
    const fcolor = '#000000'
    return (
      <div>
        {/* {!entityId && (
          <img
            style={{ maxWidth: width, maxHeight: height, display: 'block' }}
            src={'/images/goin-placeholder-logo.png'}
          />
        )} */}
        {entityId && isRounded && (
          /* Avatar for live Drivers */
          // <img className='img-rounded' style={{ height, width }} onError={this.onError} src={this.getURL()} />
          // <ConfigProvider colors={['#152d32', '#001f24', '#E1F8DC', '#2f3b22', '#052d0a', '#0f4539']}>
          <ConfigProvider colors={['#d05030', '#7ed8ec', '#127c94', '#f9d70b', '#83e7b2', '#5b65ab']}>
            <Avatar
              className='bold-avatar'
              name={this.props.name}
              size='50px'
              round={true}
              textSizeRatio={5.0}
              color='rgb(202, 241, 222)'
              src={this.getURL()}
            />
          </ConfigProvider>
        )}
        {entityId && !isRounded && (
          <img
            style={{ maxWidth: height, maxHeight: height, display: 'block' }}
            onError={this.onError}
            src={this.getURL()}
          />
        )}
        {entityId1 && !isRounded && (
          <ConfigProvider colors={['#00c2fb', '#812f75', '#7e0040', '#151ea5', '#22040a', '#ff8029']}>
            <Avatar
              className='bold-avatar'
              name={this.props.name1}
              round={true}
              size='50px'
              textSizeRatio={5.0}
              fgColor={fcolor}
              // color={'#4db87d'}
              alt={this.getURL1()}
            />
          </ConfigProvider>
        )}
      </div>
    )
  }

  private onError = () => {
    this.setState({
      onError: true
    })
  }

  private getBucketName = () => {
    return process.env.REACT_APP_ENV === 'production'
      ? process.env.REACT_APP_S3_BUCKET_PROD
      : process.env.REACT_APP_S3_BUCKET_DEV
  }

  private getURL = () => {
    const sha1 = require('sha1')
    const filename = sha1(this.props.entityId)
    const uniqueIdentifier = new Date().getTime()
    console.log('Inside getURL: ', {
      props: this.props,
      filename,
      url: `https://${this.getBucketName()}.s3.amazonaws.com/uploads/${sha1(
        this.props.entityId
      )}.png?t=${uniqueIdentifier}`
    })
    // fallback to use the local place-holder whenever there was an error fetching the imiage
    return this.state.onError
      ? /* /images/goin-placeholder-logo.png */
        ''
      : `https://${this.getBucketName()}.s3.amazonaws.com/uploads/${sha1(
          this.props.entityId
        )}.png?t=${uniqueIdentifier}`
  }
  private getURL1 = () => {
    const sha1 = require('sha1')
    const filename = sha1(this.props.entityId1)
    console.log('Inside getURL: ', {
      props: this.props,
      filename,
      url: `https://${this.getBucketName()}.s3.amazonaws.com/uploads/${filename}.png`
    })
    return this.state.onError
      ? /* Default Image '/images/goin-placeholder-logo.png' */
        /* New Default Image */
        ``
      : /* New Default Image */
        `https://${this.getBucketName()}.s3.amazonaws.com/uploads/${filename}.png`
  }
}

export default ImageLiveDrivers



// WEBPACK FOOTER //
// ./src/components/ui/ImageLiveDrivers.tsx